// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__1ncUx","contentGroupSection":"Main_contentGroupSection__OpEDg","contentSection":"Main_contentSection__zDqx-"};